import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const RetractionIcon = (props) => {
  const themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        width="27"
        height="23"
        viewBox="0 0 27 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_6597_43050)">
          <path
            d="M18.5657 6.80014L13.7657 2.05821C13.6286 1.92272 13.4914 1.85498 13.2857 1.85498H6.42856C5.67427 1.85498 5.05713 2.46466 5.05713 3.20982V19.4679C5.05713 20.213 5.67427 20.8227 6.42856 20.8227H17.4C18.1543 20.8227 18.7714 20.213 18.7714 19.4679V7.27433C18.7714 7.07111 18.7028 6.93563 18.5657 6.80014ZM13.2857 3.48079L17.1257 7.27433H13.2857V3.48079ZM17.4 19.4679H6.42856V3.20982H11.9143V7.27433C11.9143 8.0195 12.5314 8.62917 13.2857 8.62917H17.4V19.4679Z"
            fill={themeColor === 'light' ? '#000' : '#fff'}
          />
        </g>
        <path
          d="M26.3145 14.0484C26.3145 17.4156 23.5515 20.1452 20.1431 20.1452C16.7347 20.1452 13.9717 17.4156 13.9717 14.0484C13.9717 10.6813 16.7347 7.95166 20.1431 7.95166C23.5515 7.95166 26.3145 10.6813 26.3145 14.0484ZM18.1016 11.4927C17.9509 11.3439 17.7067 11.3439 17.5561 11.4927C17.4055 11.6415 17.4055 11.8828 17.5561 12.0316L19.5976 14.0484L17.5561 16.0653C17.4055 16.2141 17.4055 16.4554 17.5561 16.6042C17.7067 16.753 17.9509 16.753 18.1016 16.6042L20.1431 14.5873L22.1847 16.6042C22.3353 16.753 22.5795 16.753 22.7301 16.6042C22.8808 16.4554 22.8808 16.2141 22.7301 16.0653L20.6886 14.0484L22.7301 12.0316C22.8808 11.8828 22.8808 11.6415 22.7301 11.4927C22.5795 11.3439 22.3353 11.3439 22.1847 11.4927L20.1431 13.5096L18.1016 11.4927Z"
          fill="#FC2E25"
        />
        <path
          d="M24.5043 9.74005C23.3523 8.60198 21.7888 7.95166 20.1431 7.95166C18.4974 7.95166 16.934 8.60198 15.782 9.74005C14.63 10.8781 13.9717 12.4226 13.9717 14.0484C13.9717 15.6742 14.63 17.2188 15.782 18.3568C16.934 19.4949 18.4974 20.1452 20.1431 20.1452C21.7888 20.1452 23.3523 19.4949 24.5043 18.3568C25.6563 17.2188 26.3145 15.6742 26.3145 14.0484C26.3145 12.4226 25.6563 10.8781 24.5043 9.74005Z"
          fill="#FF7043"
        />
        <path
          d="M17.4717 11.7497C17.3766 11.6557 17.3766 11.5033 17.4717 11.4094C17.5669 11.3154 17.7211 11.3154 17.8163 11.4094L20.3237 13.8865L22.8311 11.4094C22.9263 11.3154 23.0805 11.3154 23.1757 11.4094C23.2708 11.5033 23.2708 11.6557 23.1757 11.7497L20.6682 14.2268L23.1757 16.7039C23.2708 16.7979 23.2708 16.9503 23.1757 17.0443C23.0805 17.1383 22.9263 17.1383 22.8311 17.0443L20.3237 14.5672L17.8163 17.0443C17.7211 17.1383 17.5669 17.1383 17.4717 17.0443C17.3766 16.9503 17.3766 16.7979 17.4717 16.7039L19.9792 14.2268L17.4717 11.7497Z"
          fill="white"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <clipPath id="clip0_6597_43050">
            <rect
              width="21.9429"
              height="21.6774"
              fill="white"
              transform="translate(0.942871 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default RetractionIcon;
